import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const useRouteNavigatorHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const routeNavigatorHandler = useCallback(
    (url: string) => {
      if (location.pathname === url) {
        navigate(0);
      } else {
        navigate(url);
      }
    },
    [navigate, location.pathname],
  );

  return routeNavigatorHandler;
};

export { useRouteNavigatorHandler };
